import Vue from 'vue'
import VueI18n from 'vue-i18n'
import numberFormats from './languages/numberFormats'
Vue.use(VueI18n)

export default new VueI18n({
  locales: 'en',
  fallbackLocale: 'en',
  numberFormats
})
